import { createSlice } from '@reduxjs/toolkit';
import type { FollowingState } from './types';

const initialState: FollowingState = {
  isLoading: false,
  error: false,
  followingPathways: [],
  hasMore: true,
  index: 0,
  step: 11
};

export const slice = createSlice({
  name: 'following',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getMorePosts(state) {
      const setIndex = state.index + 1;
      state.index = setIndex;
    },
    getFollowingPathways(state, action) {
      state.isLoading = false;
      state.followingPathways = action.payload;
    }
  }
});

export const { getMorePosts } = slice.actions;

export default slice.reducer;
